<template>
  <div class="table-less">
    <el-table :data="data" border size="mini">
      <el-table-column
        v-for="item in schema"
        :key="item.key"
        :prop="item.key"
        :label="item.label"
      >
        <template slot-scope="scope">
          <el-input v-if="useTextarea" type="textarea" :autosize="{ minRows: 2, maxRows: 8 }" v-model="scope.row[item.key]"></el-input>
          <el-input v-else v-model="scope.row[item.key]"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        v-if="multiple"
        prop="operate"
        label="操作"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-row>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-plus"
              @click="addRow(scope.$index)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="deRow(scope.$index)"
            ></el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    schema: {
      type: Array,
      require: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 10
    },
    useTextarea: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: []
    };
  },
  mounted() {
    this.data = [Object.fromEntries(this.schema.map(item => [item.key, ""]))];
  },
  watch: {
    data: {
      handler: function(val) {
        this.$emit("input", val);
      },
      deep: true
    }
  },
  methods: {
    addRow(index) {
      if (this.data.length < this.limit) {
        this.data.splice(
          index + 1,
          0,
          Object.fromEntries(this.schema.map(item => [item.key, ""]))
        );
      }
    },
    deRow(index) {
      if (this.data.length === 1) {
        this.data = [
          Object.fromEntries(this.schema.map(item => [item.key, ""]))
        ];
      } else {
        this.data.splice(index, 1);
      }
    }
  }
};
</script>
